// extracted by mini-css-extract-plugin
module.exports = {"Navbar":"style_Navbar__UMEFq","NavbarItem":"style_NavbarItem__3OmOD"};